module.exports = __webpack_public_path__ + "static/media/cover-desktop-1220x150.777d50f6.webp";